export default __webpack_public_path__ + "static/media/woman_with_phone_to_side.75cce47d.png";